import { render, staticRenderFns } from "./FileManagerFolder.vue?vue&type=template&id=2abd2a65&"
import script from "./FileManagerFolder.vue?vue&type=script&lang=js&"
export * from "./FileManagerFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports